<template>
  <div class="b">
    <Nav current="公司后台"></Nav>
    <div class="titleBox">
      <el-button
        type="primary"
        @click="addHandle"
        >新建项目
      </el-button>
    </div>
    <div class="el-table-box">
      <el-table
        :data="tableData"
        style="width: 100%"
        empty-text="您还没有创建过新的项目，请点击左上角“新建项目”"
        :max-height="tableHeight ? tableHeight: 0"
      >
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :min-width="col.minwidth"
          :width="col.width"
          :fixed="col.fixed"
          :type="col.type"
          show-overflow-tooltip
          v-for="(col, index) in listCol"
          :key="index"
        >
          <template v-if="col.prop == 'timeRuleCount'" scope="scope">
            {{scope.row.timeRuleCount ? scope.row.timeRuleCount : 0}}
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="280">
          <template slot-scope="scope">
            <div class="link-btn icon look l" @click="editHandle(1,scope.row)">
              查看
            </div>
            <!-- v-if="scope.row.canEdit" -->
            <div class="link-btn icon edit l" @click="editHandle(2,scope.row)">
              编辑
            </div>
            <!-- v-if="scope.row.canSplit" -->
            <div class="link-btn icon split l" @click="editHandle(3,scope.row)">
              拆分
            </div>
            <div class="link-btn icon delete l" @click="deleteHandle(scope.row)">删除</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 新建数据源弹框 -->
    <template>
      <vxe-modal v-model="dialogFormVisible" width="80%" height="400px" title="分库明细">
        <div class="hncForm">
          <el-table
            :data="tableData1"
            style="width: 100%"
            :max-height="tableHeight ? tableHeight: 0"
          >
            <el-table-column
              :prop="col.prop"
              :label="col.label"
              :min-width="col.minwidth"
              :width="col.width"
              :fixed="col.fixed"
              :type="col.type"
              show-overflow-tooltip
              v-for="(col, index) in listCol1"
              :key="index"
            >
              <template v-if="col.prop == 'departmentList'" scope="scope">
                {{departmentListHandle(scope.row.departmentList)}}
              </template>
              <template v-else-if="col.prop == 'dataSourceList'" scope="scope">
                {{ scope.row.dataSourceList ? scope.row.dataSourceList: 0}}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </vxe-modal>
      <vxe-modal v-model="dialogDeleteVisible" width="850" title="删除项目">
        <div class="hncForm">
          <div class="tip green-txt">删除{{currentRow ? currentRow.tableName : ''}}源表单动作不可逆，请您再次确定是否要删除</div>
          <div class="hncFormFoot">
            <el-button type="primary" @click="deleHandle">确定</el-button>
            <el-button class="cancel" @click="dialogDeleteVisible = false">取消</el-button>
          </div>
        </div>
      </vxe-modal>
    </template>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import Search from "@/components/Search.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import { formatNumberToThousandth } from '@/utils/utils' 
import axios from "axios";
import qs from "qs";
let key = 1
export default {
  components: {
    Nav,
    // Search,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      currentRow: null,
      tableHeight: 0,
      dialogFormVisible: false,
      dialogDeleteVisible: false,
      sizeForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      tableData1: [],
      tableData: [], //列表数据
      listCol: [
        {
          label: "序号",
          type: "index",
          width: "50",
        },
        {
          prop: "createdTime",
          label: "创建时间",
          width: "200",
        },
        {
          prop: "tableName",
          label: "源表单名称",
          minwidth: "200",
        },
        {
          prop: "systemName",
          label: "源系统名称",
          minwidth: "200",
        },
        {
          prop: "systemDomain",
          label: "源系统域名",
          minwidth: "300",
        },
        {
          prop: "timeRuleCount",
          label: "分库次数",
          minwidth: "200",
        }
      ],
      listCol1: [
        {
          label: "序号",
          type: "index",
          width: "50",
        },
        {
          prop: "targetDatasourceName",
          label: "新数据源名称",
          width: "200",
          id: "id",
        },
        {
          prop: "startTime",
          label: "启动的时间",
          minwidth: "180",
        },
        {
          prop: "endTime",
          label: "关闭的时间",
          minwidth: "180",
        },
        {
          prop: "departmentList",
          label: "组织的节点",
          minwidth: "200",
        },
        {
          prop: "dataSize",
          label: "条数",
          minwidth: "240",
        }
      ],
    };
  },
  mounted() {
    this.getTableHeight()
    this.getList();
  },
  methods: {
    departmentListHandle(lists){//查看详情
      let tempArr = []
      if(lists?.length){
        for (let i = 0; i < lists.length; i++) {
          const element = lists[i];
          if(element.departmentName){
            tempArr.push(`【${element.departmentName}】`)
          }
        }
      }
      return tempArr.join('')
    },
    deleteHandle(row){
      this.dialogDeleteVisible = true
      this.currentRow = row
    },
    deleHandle() {
      let _this = this;
      let params = {
        id: _this.currentRow.id,
        tableName: _this.currentRow.tableName
      }
      http.delete(apiData.tableRuleDetailDelete, true, params, (res) => {
        if (res.data.code == 200) {
          _this.dialogDeleteVisible = false
          _this.getList();
          _this.$message.success("删除成功");
        } else {
          _this.$message.error(res.data.msg);
        }
      });
    },
    getTableHeight(){
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        let commonTopbar = document.querySelector('.commonTopbar').offsetHeight;
        let header = document.querySelector('.header').offsetHeight;
        this.tableHeight = parseInt(this.clientHeight - commonTopbar - header - 180);
      })
    },
    getListData1(row){
      let _this = this
      let params = {
        id: row.id,
        tableName: row.tableName
      }
      http.get(apiData.listTableRuleDatasource, true, params, (res) => {
        const resData = res?.data?.data || []
        resData.forEach(ele => {
          const {
            dataSize = 0
          } = ele
          ele.dataSize = formatNumberToThousandth(dataSize)
        })
        this.tableData1 = resData
      });
      // http.get(apiData.tableRuleDetail, true, params , (res) => {
      //   let timeRule = res.data.data.timeRule
      //   let tempArr = []
      //   for (let i = 0; i < timeRule.length; i++) {
      //     const element = timeRule[i];
      //     for (let j = 0; j < element.expression.length; j++) {
      //       const e = element.expression[j];
      //       let temp = {
      //         startTime: element.startTime,
      //         endTime: element.endTime,
      //         targetDatasource: e.targetDatasource,
      //         departmentList: e.fkTableRuleTimeExpressionDepartment ? e.fkTableRuleTimeExpressionDepartment: e.departmentList,
      //         departmentListName: e.departmentListName,
      //         // 缺条数

      //       }
      //       tempArr.push(temp)
      //     }
      //   }
      //   console.log(tempArr)
      //   this.tableData1 = tempArr
      // });
    },
    getList(){
      let _this = this
      let params = {
        "host": '',//"数据库对应的主机ip",
        "name": '',//"数据源名称",
        "systemId": '',//"所属系统id,从系统管理表去选择"
      };
      http.get(apiData.tableRuleList, true, params, (res) => {
        this.tableData = res.data.data;
      });
    },
    addHandle(type,row) {
      this.$router.push("/sharding/add");
    },
    //编辑
    editHandle(type,row) {
      if(type == 1){
        this.dialogFormVisible = true
        this.getListData1(row)
      }else if(type == 2){
        this.$router.push({ name: "ShardingEdit", query: { id: row.id, tableName: row.tableName} });
      }else if(type == 3){
        this.$router.push({ name: "ShardingSplit", query: { id: row.id, tableName: row.tableName} });
      }
    },
  },

};
</script>
<style scoped lang="less">
@import './index';
.titleBox {
  button {
    padding: 8px 20px;
    width: auto;
  }
}
.hncForm {
  .tip {
    padding: 80px 0;
    font-weight: bold;
    text-align: center;
    font-size: 18px;
  }
}
</style>